module.exports = __webpack_public_path__ + "static/media/logo2.f22565b3.png";